import { render, staticRenderFns } from "./ModalRequisitionsMailboxes.vue?vue&type=template&id=747fba2f&lang=pug&"
import script from "./ModalRequisitionsMailboxes.vue?vue&type=script&lang=js&"
export * from "./ModalRequisitionsMailboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports